import { render } from "./ModelLightingClusters.vue?vue&type=template&id=6794b452"
import script from "./ModelLightingClusters.vue?vue&type=script&lang=js"
export * from "./ModelLightingClusters.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./ModelLightingClusters.vue?vue&type=style&index=0&id=6794b452&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script